/**
 * Native platform bootstrap (Capacitor).
 *
 * - Configures status bar to match app theme (dark BG, light text).
 * - Hides the splash screen once React has mounted.
 * - Initializes RevenueCat with the correct platform-specific API key,
 *   conditional on whether keys are present in the build environment.
 *
 * On the web (Capacitor.isNativePlatform() === false), this module is
 * effectively a no-op so the existing web Stripe flow is untouched.
 */
import { Capacitor } from "@capacitor/core";

export function isNative() {
  return Capacitor.isNativePlatform();
}

export function platform() {
  return Capacitor.getPlatform(); // "web" | "ios" | "android"
}

async function configureStatusBar() {
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setBackgroundColor({ color: "#09090B" });
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setOverlaysWebView({ overlay: false });
  } catch (e) {
    console.warn("StatusBar configure failed:", e);
  }
}

async function hideSplash() {
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide();
  } catch (e) {
    console.warn("SplashScreen hide failed:", e);
  }
}

/**
 * One-time native init at app boot. Safe to call on web (no-op).
 */
export async function initNativeShell() {
  if (!isNative()) return;
  await configureStatusBar();
  // Give React a beat to paint the first frame before tearing down the splash.
  setTimeout(() => { hideSplash(); }, 250);
}
